import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetSystemReportsTableData: '[GetSystemReportsTableData] Action',
  SetSystemReportsData: '[SetSystemReportsData] Action',
  GetSystemReportsTranslateData: '[GetSystemReportsTranslateData] Action',

  GetReportDetailTableData: '[GetReportDetailTableData] Action',
  SetReportDetailData: '[SetReportDetailData] Action',
  GetReportDetailTranslateData: '[GetReportDetailTranslateData] Action',

  GetServerReportDetailTranslateData:'[GetServerReportDetailTranslateData] Action',
}

const initialSystemReportsState: ISystemReportsState = {
  reportsColumnList: [],
  reportsColumnValues: [],
  reportsDefinitions: [],
  reportsColumnNames: [],
  reportsDataTypes: [],
  reportsDe: [],
  reportsEn: [],
  reportssOptions: [],

  reportDetailColumnList: [],
  reportDetailColumnValues: [],
  reportDetailDefinitions: [],
  reportDetailColumnNames: [],
  reportDetailDataTypes: [],
  reportDetailDe: [],
  reportDetailEn: [],
  reportDetailOptions: [],

  serverReportDetailColumnList: [],
  serverReportDetailColumnValues: [],
  serverReportDetailDefinitions: [],
  serverReportDetailColumnNames: [],
  serverReportDetailDataTypes: [],
  serverReportDetailDe: [],
  serverReportDetailEn: [],
  serverReportDetailOptions: [],

  serverreportdefinitions: [],
}

export interface ISystemReportsState {
  reportsColumnValues: [],
  reportsColumnList: [],
  reportsDefinitions: []
  reportsColumnNames: [],
  reportsDataTypes: [],
  reportsDe: [],
  reportsEn: [],
  reportssOptions: [],

  reportDetailColumnList: [],
  reportDetailColumnValues: [],
  reportDetailDefinitions: [],
  reportDetailColumnNames: [],
  reportDetailDataTypes: [],
  reportDetailDe: [],
  reportDetailEn: [],
  reportDetailOptions: [],

  serverreportdefinitions: [],

  serverReportDetailColumnList: [],
  serverReportDetailColumnValues: [],
  serverReportDetailDefinitions: [],
  serverReportDetailColumnNames: [],
  serverReportDetailDataTypes: [],
  serverReportDetailDe: [],
  serverReportDetailEn: [],
  serverReportDetailOptions: [],

}

export const reducer = persistReducer(
  { storage, key: 'portal-SystemReports', whitelist:  [ ] },
  (state: ISystemReportsState = initialSystemReportsState, action: any) => {
    switch (action.type) {
      case actionTypes.GetSystemReportsTableData: {
        const reportsColumnValues = JSON.parse(action.payload.data.reportdefinitionHeaders);
        const serverreportdefinitions = action.payload.data.serverreportdefinitions;
        let headers = JSON.parse(action.payload.data.headers);
        let reportsDefinitions = JSON.parse(action.payload.data.definitions);
        let reportsColumnNames = action.payload.data.columnNames;
        let reportsDataTypes = action.payload.data.dataTypes;
        let reportsColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          reportsColumnList.push(newElement[0]);
        });
        return { ...state, reportsColumnList, reportsColumnValues, reportsDefinitions, reportsDataTypes , reportsColumnNames, serverreportdefinitions};
      }

      case actionTypes.GetReportDetailTableData: {
        const reportDetailColumnValues = JSON.parse(action.payload.data.reportdefinitionDetails);
        let headers = JSON.parse(action.payload.data.headers);
        let reportDetailDefinitions = JSON.parse(action.payload.data.definitions);
        let reportDetailColumnNames = action.payload.data.columnNames;
        let reportDetailDataTypes = action.payload.data.dataTypes;
        let reportDetailColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          reportDetailColumnList.push(newElement[0]);
        });

        let serverheaders = action.payload.data.serverheaders;
        let serverReportDetailDefinitions = action.payload.data.serverdefinitions;
        let serverReportDetailColumnList: any = [];
        serverheaders.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          serverReportDetailColumnList.push(newElement[0]);
        });
        return { ...state, reportDetailColumnList, reportDetailColumnValues, reportDetailDefinitions, reportDetailDataTypes, reportDetailColumnNames,serverReportDetailColumnList , serverReportDetailDefinitions};
      }
    
      case actionTypes.SetSystemReportsData: {
        const reportsColumnValues = action.payload.data;
        return { ...state, reportsColumnValues };
      }

      case actionTypes.SetReportDetailData: {
        const reportDetailColumnValues = action.payload.data;
        return { ...state, reportDetailColumnValues };
      }

      case actionTypes.GetSystemReportsTranslateData: {
        const reportsDe = JSON.parse(action.payload.data.de);
        const reportsEn = JSON.parse(action.payload.data.en);
        return { ...state, reportsDe, reportsEn };
      }

      case actionTypes.GetReportDetailTranslateData: {
        const reportDetailDe = JSON.parse(action.payload.data.de);
        const reportDetailEn = JSON.parse(action.payload.data.en);
        return { ...state, reportDetailDe, reportDetailEn };
      }

      case actionTypes.GetServerReportDetailTranslateData: {
        const serverReportDetailDe = JSON.parse(action.payload.data.de);
        const serverReportDetailEn = JSON.parse(action.payload.data.en);
        return { ...state, serverReportDetailDe, serverReportDetailEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getTranslateData: (data: any) => ({ type: actionTypes.GetSystemReportsTranslateData, payload: { data } }),
  getSystemReportsTableData: (data: any) => ({ type: actionTypes.GetSystemReportsTableData, payload: { data } }),
  setSystemReportsData: (data: any) => ({ type: actionTypes.SetSystemReportsData, payload: { data } }),
  getDetailTranslateData: (data: any) => ({ type: actionTypes.GetReportDetailTranslateData, payload: { data } }),
  getReportDetailTableData: (data: any) => ({ type: actionTypes.GetReportDetailTableData, payload: { data } }),
  setReportDetailData: (data: any) => ({ type: actionTypes.SetReportDetailData, payload: { data } }),
  getServerDetailTranslateData: (data: any) => ({ type: actionTypes.GetServerReportDetailTranslateData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
